import React from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';

import Button from '@style-guide/components/Button';
import LinkButton from '@style-guide/components/LinkButton';

import Divider from '@components/Divider';

import ButtonWrapper from './shared/ButtonWrapper';
import DataItem from './shared/DataItem';
import Inner from './shared/Inner';
import ItemTitle from './shared/ItemTitle';
import ItemWrapper from './shared/ItemWrapper';
import NoResultsMessage from './shared/NoResultsMessage';
import Title from './shared/Title';
import Wrapper from './shared/Wrapper';

class FindALawyerSection extends React.Component {
  constructor() {
    super();

    this.state = {
      isExpanded: false,
    };

    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.renderItems = this.renderItems.bind(this);
  }

  toggleExpanded() {
    this.setState({
      isExpanded: true,
    });
  }

  renderItems() {
    const { isExpanded } = this.state;
    const { items } = this.props;
    const itemsWithIds = items.map((x, index) => ({
      ...x,
      id: index,
    }));

    const itemsToRender = itemsWithIds.map((lawyer, index) => {
      if (index >= 5 && !isExpanded) {
        return undefined;
      }

      return (
        <React.Fragment
          key={lawyer.id}
        >
          {index > 0 && (
            <Divider
              hasDecorator={false}
              margin="15px 0px"
            />
          )}
          <ItemWrapper
            href={lawyer.Url}
          >
            <ItemTitle>{lawyer.Name}</ItemTitle>
            {lawyer.OfficePhone && (
              <DataItem>
                <span>Office Phone: </span> {lawyer.OfficePhone}
              </DataItem>
            )}
            {lawyer.City && (
              <DataItem>
                <span>City: </span> {lawyer.City}
              </DataItem>
            )}
          </ItemWrapper>
        </React.Fragment>
      );
    });

    return itemsToRender;
  }

  render() {
    const {
      items,
      searchLink,
    } = this.props;
    const { isExpanded } = this.state;

    return (
      <Wrapper>
        <Title>Find A Lawyer ({items.length === 10 ? '10 or more' : items.length})</Title>
        <Inner>
          {is.not.empty(items) && this.renderItems()}
          {is.empty(items) && (
            <React.Fragment>
              <NoResultsMessage>No Results found.</NoResultsMessage>
              <ButtonWrapper>
                <LinkButton
                  href={searchLink}
                >
                  ADVANCED SEARCH
                </LinkButton>
              </ButtonWrapper>
            </React.Fragment>
          )}
          {!isExpanded && !is.empty(items) && items.length > 5 && (
            <ButtonWrapper>
              <Button
                onClick={() => this.toggleExpanded()}
              >
                Show More
              </Button>
            </ButtonWrapper>
          )}
          {isExpanded && is.not.empty(items) && (
            <ButtonWrapper>
              <LinkButton
                href={searchLink}
              >
                View All Results in this Category
              </LinkButton>
            </ButtonWrapper>
          )}
        </Inner>
      </Wrapper>
    );
  }
}

FindALawyerSection.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  searchLink: PropTypes.string,
};

FindALawyerSection.defaultProps = {
  searchLink: '',
};

FindALawyerSection.displayName = 'FindALawyerSection';

export default FindALawyerSection;
